import React from 'react';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from "react-toastify";

export const transitionOptions = {
    Slide,
    Zoom,
    Flip,
    Bounce
}

const SnackBar = () => <ToastContainer hideProgressBar position="top-right"></ToastContainer>
// const SnackBar = () => <frameElement/>
const getHeaderHeight = () => {
    const headerSelector = document.querySelector('header')
    if (!headerSelector) {
        console.error('Header not found. Setting the height to an arbitrary value of 126px.');
        return 126;
    }
    return headerSelector.offsetHeight + headerSelector.offsetTop;
}

export const infoToast = (message, configs)=>{
    const {statusIcon=false, closeButton=false, autoClose=5000, position, type=toast.TYPE.INFO, hideProgressBar=true, closeOnClick=false, pauseOnHover=true, pauseOnFocusLoss=true, transition=Bounce, toastId, className, toastClosed} = configs || {};
    let ReturnToastId = toast.info(message, {
        bodyClassName: statusIcon ? 'statusIcon body2 h-emphasis': 'noStatusIcon body2 h-emphasis',
        autoClose,
        closeButton,
        position,
        type,
        hideProgressBar,
        closeOnClick,
        pauseOnHover,
        pauseOnFocusLoss,
        transition,
        toastId,
        className,
        onClose: toastClosed,
        style: {
            top: getHeaderHeight()
        }
    });
    return ReturnToastId;
}
export const successToast = (message, configs)=>{
    const {statusIcon=false, closeButton=false, autoClose=5000, position, type=toast.TYPE.SUCCESS, hideProgressBar=true, closeOnClick=false, pauseOnHover=true, pauseOnFocusLoss=true, transition=Bounce, toastId, className, toastClosed} = configs || {};
    let ReturnToastId = toast.success(message, {
        bodyClassName: statusIcon ? 'statusIcon body2 h-emphasis': 'noStatusIcon body2 h-emphasis',
        autoClose,
        closeButton,
        position,
        type,
        hideProgressBar,
        closeOnClick,
        pauseOnHover,
        pauseOnFocusLoss,
        transition,
        toastId,
        className,
        onClose: toastClosed,
        style: {
            top: getHeaderHeight()
        }
    });
    return ReturnToastId;
}

export const warningToast = (message, configs) =>{
    const {statusIcon=false, closeButton=true, autoClose=false, position, type=toast.TYPE.WARNING, hideProgressBar=true, closeOnClick=false, pauseOnHover=true, pauseOnFocusLoss=true, transition=Bounce, toastClosed} = configs || {};
    let toastId = toast.warning(message, {
        bodyClassName: statusIcon ? 'statusIcon body2 h-emphasis': 'noStatusIcon body2 h-emphasis',
        autoClose,
        closeButton,
        position,
        type,
        hideProgressBar,
        closeOnClick,
        pauseOnHover,
        pauseOnFocusLoss,
        transition,
        onClose: toastClosed,
        style: {
            top: getHeaderHeight()
        }
    });
    return toastId;
}

export const errorToast = (message, configs) => {
    const {statusIcon=false, closeButton=true, autoClose=false, position, type=toast.TYPE.ERROR, hideProgressBar=true, closeOnClick=false, pauseOnHover=true, pauseOnFocusLoss=true, transition=Bounce} = configs || {};
    let toastId = toast.error(message, {
        bodyClassName: statusIcon ? 'statusIcon body2 h-emphasis': 'noStatusIcon body2 h-emphasis',
        autoClose,
        closeButton,
        position,
        type,
        hideProgressBar,
        closeOnClick,
        pauseOnHover,
        pauseOnFocusLoss,
        transition,
        style: {
            top: getHeaderHeight()
        }
    });
    return toastId;
}

export const updateToast = (toastId, configs) =>{
    const {closeButton=true, autoClose=false, position, content, type=toast.TYPE.INFO, hideProgressBar=true, closeOnClick=false, pauseOnHover=true, pauseOnFocusLoss=true, transition=Bounce, className} = configs || {};
    toast.update(toastId, {
        render: content,
        closeButton,
        autoClose,
        position,
        type,
        hideProgressBar,
        closeOnClick,
        pauseOnHover,
        pauseOnFocusLoss,
        transition,
        className,
        toastId,
        style: {
            top: getHeaderHeight()
        }
      });
}

export const isSnackBarActive = (id) => toast.isActive(id);

export default SnackBar;